import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import { pick } from 'lodash';
import displayName from 'component-lib/displayName';

import DayBox from './DayBox';

import styles from '../Datepicker.scss';

const MAX_DAY_BOXES = 42;

class ListOfDays {
    constructor(options) {
        this.todaysDate = moment();
        this.currentDate = options.currentDate;
        this.selectedDate = options.selectedDate;
        this.dateRange = options.dateRange;
        this.listOfDays = [];
    }

    checkIsDateInRange(date) {
        const onMinSide =
      this.dateRange.min
          ? moment(this.dateRange.min).startOf('days') <= date
          : true;
        const onMaxSide =
      this.dateRange.max
          ? moment(this.dateRange.max).endOf('days') > date
          : true;

        return onMinSide && onMaxSide;
    }

    buildListOfPreDays() {
        const currentDateWeekday = this.currentDate.weekday();
        const actualDate = moment(this.currentDate)
            .startOf('month')
            .subtract(currentDateWeekday + 1, 'days');

        let weekday = 0;

        while (weekday < currentDateWeekday) {
            this.listOfDays.push({
                date: actualDate.add(1, 'days').clone(),
                boxClass: 'inactive-day-box',
            });
            weekday += 1;
        }
    }

    buildListOfDays() {
        const endDate = moment(this.currentDate).endOf('month');
        let actualDate = moment(this.currentDate);

        while (!actualDate.isAfter(endDate)) {
            const isSelected = actualDate.startOf('days').isSame(this.selectedDate.startOf('days'));
            const dayObject = {
                date: actualDate,
                boxClass: 'inactive-day-box',
            };

            if (this.checkIsDateInRange(actualDate)) {
                const boxClass =
          actualDate.isSame(moment(), 'day')
              ? 'today-day-box'
              : 'day-box';

                Object.assign(
                    dayObject,
                    {
                        boxClass,
                        isSelected,
                        isActive: true,
                    },
                );
            }
            this.listOfDays.push(dayObject);
            actualDate = moment(actualDate).add(1, 'days');
        }
    }

    buildListOfAfterDays() {
        const actualDate = moment(this.currentDate).endOf('month');

        while (this.listOfDays.length < MAX_DAY_BOXES) {
            this.builtDayBoxesNum += 1;
            this.listOfDays.push({
                date: actualDate.add(1, 'days').clone(),
                boxClass: 'inactive-day-box',
            });
        }
    }

    getDays() {
        this.buildListOfPreDays();
        this.buildListOfDays();
        this.buildListOfAfterDays();

        return this.listOfDays;
    }
}

export default class DatepickerBody extends Component {
    static displayName = displayName('Widgets/Datepicker/Body');

    static propTypes = {
        currentDate: PropTypes.object,
        selectedDateFormat: PropTypes.string,
        dateRange: PropTypes.object,
        selectedDate: PropTypes.object,
        onSelectDate: PropTypes.func,
    };

    static defaultProps = {
        currentDate: {},
        selectedDateFormat: '',
        dateRange: {},
        selectedDate: {},
        onSelectDate: () => {},
    };

    onSelectDay(date) {
        return (
            () => {
                this.props.onSelectDate(date.toDate());
            }
        );
    }

    render() {
        const dayList = new ListOfDays(pick(this.props, ['currentDate', 'selectedDate', 'dateRange']),).getDays();

        return (
            <div className={styles['datepicker-block']}>
                {
                    dayList.map((dayObject) => {
                        const newDayObject = { ...dayObject };

                        if (dayObject.isActive) {
                            newDayObject.onClick = this.onSelectDay(dayObject.date);
                        }

                        return (
                            <DayBox key={dayObject.date} {...newDayObject} />
                        );
                    })
                }
            </div>
        );
    }
}
